<template>
    <div class="order-detail-section mg20">
        <h3>回款计划</h3>
        <el-table :data="test" border style="margin:20px; width:97%">
            <el-table-column label="修订项" prop="title">
                <template slot-scope="scope">
                    {{scope.row.col_name}}
                </template>
            </el-table-column>
            <el-table-column label="修订后内容"  prop="ccc">
                <template slot-scope="scope">
                    <span v-html=scope.row.new_content></span>
                </template>
            </el-table-column>
            <el-table-column label="原内容" prop="bbb">
                <template slot-scope="scope" >
                    <span v-html=scope.row.old_content></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {OrderMixin} from "~/services/OrderMixin";
    export default {
        name: "invoice",
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: {
                required: false
            }
        },
        watch: {
            order(v, s) {
                if(this.order.content){
                    this.test = this.order.content.plan_pay.map(item=> {
                        item.col_name = '新增回款';
                        if(item.created_at){
                            item.col_name = '更新回款';
                            let old = this.order.before_content.finance.plan_pay.find(i=>{
                                return i.id == item.id;
                            })
                            item.old_content = this.getContent(old);
                        }else{
                            item.old_content = "无";
                        }
                        item.new_content = this.getContent(item);
                        if(item.new_content != item.old_content){
                            item.new_content = '<span style="color: red">'+item.new_content+'</span>'
                        }
                        return item;
                    });
                    /**
                     * 有可能有删除的情况存在
                     * 需要查找出删除的回款信息
                     */
                    let active_invoice = [];
                    this.test.map(i=>{
                        active_invoice.push(i.id);
                    })
                    let del_invoice = this.order.before_content.finance.plan_pay.filter(item=>{
                        return !active_invoice.includes(item.id);
                    })
                    if(del_invoice){//说明有删除的
                        del_invoice.map(item=>{
                            item.old_content = this.getContent(item);
                            item.new_content = '<span style="color: red">已删除</span>'
                            item.col_name = "删除回款";
                            this.test.push(item);
                        })
                    }
                }
            }
        },
        mounted() {
            let params = {
                fields: 'id,name',
                scenario: 'all-user'
            };
        },
        data() {
            return {
                test:[
                    {
                        field:'main',
                        col_name:'发票ID',
                        new_content:'',
                        old_content:'',
                    }
                ],
                type:[
                    "普通发票(纸质)",
                    "专用发票(纸质)",
                    "普通发票(电子)",
                    "专用发票(电子)"
                ]
            }
        },
        methods:{
            getContent(item){
                let content = '';
                content += "计划回款时间:"+item.plan_at+"<br/>";
                content += "计划回款金额:"+item.plan_amount+"<br/>";
                return content;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/finance/repay_plan.vue